module.exports = __webpack_public_path__ + "img/pro_mega10_05.f185817d.jpg";